(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["currency-select"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input', function (event) {
    const search = event.target;
    if (!(search instanceof HTMLInputElement) || !search.matches('[data-pawly-currency-search]')) return;
    const menu = search.closest('.pawly-currency-menu');
    const query = search.value.trim().toLowerCase();
    menu.querySelectorAll('[data-pawly-currency-option]').forEach(function (option) {
      option.hidden = !option.textContent.toLowerCase().includes(query);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
